/**
 * Sessions API endpoints
 */

import { get, post, del } from './client';
import type { Session, Message } from '../types';

interface SessionsResponse {
  sessions: Session[];
}

interface SessionResponse {
  session: Session;
  messages: Message[];
}

interface NewSessionResponse {
  uuid: string;
  title: string;
}

/**
 * Get all sessions for current user
 */
export async function getSessions(): Promise<Session[]> {
  const data = await get<SessionsResponse>('/api/sessions');
  return data.sessions || [];
}

/**
 * Get a single session with messages
 */
export async function getSession(
  sessionUuid: string
): Promise<{ session: Session; messages: Message[] }> {
  const data = await get<SessionResponse>(`/api/sessions/${sessionUuid}`);
  return {
    session: data.session,
    messages: data.messages || [],
  };
}

/**
 * Create a new session
 */
export async function createSession(): Promise<string> {
  const data = await post<NewSessionResponse>('/api/sessions');
  return data.uuid;
}

/**
 * Delete a session
 */
export async function deleteSession(sessionUuid: string): Promise<void> {
  await del(`/api/sessions/${sessionUuid}`);
}
